import { useInteractiveDiagramContext } from './InteractiveDiagramContext';
import { useCallback } from 'react';
export var useNodeState = function (nodeId) {
    var _a;
    var _b = useInteractiveDiagramContext(), state = _b.state, internalHelpers = _b.internalHelpers;
    var position = (_a = state.nodes[nodeId]) === null || _a === void 0 ? void 0 : _a.position;
    var nodeShape = internalHelpers.nodeShapes[nodeId];
    var addNodeShapeToContext = useCallback(function (shape) {
        internalHelpers.addNodeShapeToContext(nodeId, shape);
    }, [nodeId]);
    var moveNode = useCallback(function (dx, dy) {
        internalHelpers.moveNode(nodeId, dx, dy);
    }, [nodeId]);
    return [
        position,
        nodeShape,
        moveNode,
        addNodeShapeToContext,
    ];
};
//# sourceMappingURL=nodeState.js.map